import type { TraderProfile } from "domain/copyTrading/types";

type Props = {
  traders: TraderProfile[];
  followingCount: number;
};

function formatCompact(n: number): string {
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `$${(n / 1_000).toFixed(1)}K`;
  return `$${n.toFixed(0)}`;
}

export function StatsHero({ traders, followingCount }: Props) {
  // "Registered traders" — every leader on the board counts, not only ones who
  // already have followers (a brand-new leader with 0 followers is still active).
  const activeTraders = traders.length;
  const totalFollowers = traders.reduce((s, t) => s + t.followerCount, 0);
  const totalCopyTrades = traders.reduce((s, t) => s + (t.totalTrades ?? 0), 0);

  const stats = [
    {
      label: "Active Leaders",
      value: activeTraders.toLocaleString(),
      sub: "registered traders",
      accent: "blue",
    },
    {
      label: "Total Followers",
      value: totalFollowers.toLocaleString(),
      sub: "copy accounts",
      accent: "green",
    },
    {
      label: "Trades Copied",
      value: totalCopyTrades.toLocaleString(),
      sub: "all time",
      accent: "orange",
    },
    {
      label: "You Follow",
      value: followingCount.toString(),
      sub: followingCount === 1 ? "trader" : "traders",
      accent: "purple",
    },
  ];

  return (
    <div className="CT-hero">
      {stats.map((s) => (
        <div key={s.label} className={`CT-hero-card CT-hero-card--${s.accent}`}>
          <div className="CT-hero-card__label">{s.label}</div>
          <div className="CT-hero-card__value">{s.value}</div>
          <div className="CT-hero-card__sub">{s.sub}</div>
        </div>
      ))}
    </div>
  );
}
